import { AxiosError } from 'axios'
import { useTranslation } from 'hooks/useTranslation'
import { OAuthErrorResponse } from 'services/api/iam/manager/interfaces/OAuthErrorResponse'

export const useOAuthErrorMessage = (error?: AxiosError<OAuthErrorResponse> | null) => {
  const { t } = useTranslation()
  if (!error) return ''
  const data = error.response?.data
  if (data?.error === 'invalid_grant')
    return t(
      'Esta autorização expirou ou foi encerrada. Volte ao aplicativo e inicie a conexão novamente.'
    )
  if (data?.error_description === 'password_reset_required')
    return t('Você precisa redefinir sua senha antes de continuar.')
  if (error.response?.status === 429)
    return t('Muitas tentativas. Aguarde alguns minutos antes de tentar novamente.')
  if (data?.error_description === 'Invalid verification code')
    return t('O código digitado não é válido')
  if (data?.error === 'access_denied')
    return t('Não foi possível autenticar. Confira seus dados e tente novamente.')
  return t('Não foi possível concluir a solicitação. Tente novamente.')
}
